import type { ActionOption, MatrixModel, OutputValueRange } from '~/dashboard/views/workflows/store/engine/types';

export const transformCellValue = (
  matrixDataType: MatrixModel['matrixDataType'],
  value: string,
) => {
  if (!value) return null;

  switch (matrixDataType) {
    case 'number':
      // the user could input a string value in a numeric matrix's cell
      return isNaN(Number(value)) ? null : Number(value);
    case 'string':
      return String(value);
    default:
      return null;
  }
};

export const getShouldDefineValueRanges = (
  outputValueRange: ActionOption,
  defineValueRanges?: boolean,
) => (
  outputValueRange?.jsonValue && (
    defineValueRanges !== false // acceptable values are true or undefined
  )
);

export const getCellColor = ({
  cellValue,
  hasValueRangeConfig,
  outputValueRange,
}: {
  cellValue: number | null;
  hasValueRangeConfig: boolean;
  outputValueRange: OutputValueRange[];
}) => {
  const cellColor = hasValueRangeConfig && typeof cellValue === 'number'
    ? outputValueRange?.find(({ minValue, maxValue }, index, array) => {
      const isLastRange = index === array.length - 1;
      return (minValue === null && maxValue > cellValue)
        || (minValue <= cellValue && (isLastRange ? maxValue >= cellValue : maxValue > cellValue))
        || (minValue <= cellValue && maxValue === null);
    })?.color : null;
  return cellColor;
};
